export function getYearNmonth(data) {
    const date = new Date(data);
    let formatted = date.toLocaleDateString('pt-PT', { month: 'long', year: 'numeric' });
    formatted = formatted.charAt(0).toUpperCase() + formatted.slice(1);

    const [month, year] = formatted?.split(' de ');

    return { year, month }
}

export function getCurrentMonthYear(ano) {
    const date = new Date();

    const month = date.toLocaleString('pt-PT', { month: 'long' });
    const capitalizedMonth = month.charAt(0).toUpperCase() + month.slice(1);

    const year = date.getFullYear();

    return `${capitalizedMonth}-${ano ? ano : year}`;
}
